
export const getReportId = "/DynamicReport/GetReportId";
export const getInterfaceId = "/DynamicForm/GetInterfaceId";
export const GenerateDynamicForm = "api/DynamicForm/GenerateForm";
export const ValidateDynamicFormFields = "/DynamicForm/ValidateFormFieldsAsync";

export const getFormConfigDetails = "/DynamicForm/GenerateForm";
export const executeAction = "/DynamicForm/ExecuteAction";
export const getFormValues = "/DynamicForm/GetFormValues";
export const getDynamicFormTabs = "/DynamicForm/GetDynamicFormTabs";
export const getCascadeFieldOptions = "/DynamicForm/GetCascadeFieldOptions";
export const UploadFile = "/DynamicForm/UploadFile";

// Dynamic Report Api

export const generateReport = "/DynamicReport/GenerateReport";
export const fetchReportData = "/DynamicReport/FetchReportData";
export const fetchReportExcelData = "/DynamicReport/FetchReportExcelData";
export const FetchReportPdfData = "/DynamicReport/FetchReportPdfData";
export const executeReportAction = "/DynamicReport/ExecuteAction";
export const fetchStaticTableData = "/DynamicReport/FetchStaticTableData";

// Login Api
export const getAuthenticationConfig = "/Login/GetAuthenticationConfig";
export const userLogin = "/Login/UserLogin";
export const SetRole = "/Login/SetRole";
export const getValidationMessages = "/Login/GetValidationMessages";
export const getForgotPassword = "/Login/ForgotPassword"; // NOSONAR: Component import
export const getResetPassword = "/Login/ResetPassword"; // NOSONAR: Component import
export const getPasswordExists = "/Login/GetPasswordExists"; // NOSONAR: Component import
export const generateTokenForAuthentication =
  "/Login/GenerateTokenForAuthentication";
export const azuregenerateTokenForAuthentication =
  "/Login/AzureGenerateTokenForAuthentication";
export const getvalidateOtp = "/Login/ValidateOTP";
export const getRefreshtoken = "/Auth/Refresh";
export const getAuthenticationType = "/Login/GetAuthenticationType";
export const userLogout = "/Login/LogoutUser";
export const getUserAccess = "/Login/GetUserAccess";

// Added a common method for the getting the authconfig data.
export const getConfigData = "/Auth/GetConfigData";
export const getPasswordEncryptionConfigData =
  "/Auth/GetPasswordEncryptionConfigData"; // NOSONAR: Component import

export const deleteRecordById = "/DynamicForm/DeleteRecordById";
export const getPermissions = "/Login/GetPermissions";

// Role Management
export const getUserRoles = "/Roles/GetUserRoles";
export const getDynamicMenu = "/DynamicForm/GetDynamicMenu";

//Schedule Master
export const testScheduler = "/DynamicForm/TestScheduler";
export const InsertUpdateSchedule = "/Scheduler/InsertUpdateSchedule";
export const GetMessageTemplate = "/Scheduler/GetMessageTemplate";
export const GetScheduleById = "/Scheduler/GetScheduleById";
export const StartPauseScheduleById = "/Scheduler/StartPauseScheduleById";

export const DeleteTestSHMasterById = "/DynamicForm/DeleteTestSHMasterById";

//by durga

//Task Detail Tab
export const getAssignedTo = "/TaskDetail/GetAssignedToOptions";
export const getTaskOwnerStatus = "/TaskDetail/GetTaskOwnerStatusOptions";
export const getTaskInvestigatorStatus = "/TaskDetail/GetTaskInvestigatorStatusOptions"; 

export const getCorrActionOwnerStatus = "/TaskDetail/GetCorrActionOwnerStatusOptions";
export const getCorrActionCentralQAStatus = "/TaskDetail/GetCorrActionCentralQAOptions"; 

export const getTaskSummaryDetails = "/TaskDetail/GetTaskSummaryDetails"; 
export const InsertTasksAsync = "/TaskDetail/InsertTasksAsync" ;
export const UpdateTaskAsync = "/TaskDetail/UpdateTaskAsync" ;
export const getRequestDetailsById = "/TaskDetail/FetchRequestDetailsData" ;
export const FetchRequestOrUserContext = "/Custom/FetchRequestOrUserContext" ;

export const GetCorrectiveActionSummaryDetails = "/TaskDetail/GetCorrectiveActionSummaryDetails"; 
export const InsertCorrectiveActionAsync = "/TaskDetail/InsertCorrectiveActionAsync" ;
export const UpdateCorrectiveActionAsync = "/TaskDetail/UpdateCorrectiveActionAsync" ;
export const QAClosureSubmitAsync = "/TaskDetail/QAClosureSubmitAsync" ;

export const GetRolesSystemName = "/Master/GetRolesSystemName" ;

export const CustomFunction = "/DynamicForm/CustomFunction";
export const getRequestHistory = "/Custom/GetRequestHistoryDetails";
export const getTaskHistory = "/TaskDetail/GetTaskHistoryDetails";
export const getCorrectiveActionHistory = "/TaskDetail/GetCorrectiveActionHistoryDetails";



export const InsertUpdateUserMaster = "/UserAccessMaster/InsertUpdateUserMaster";

// Request Detail
export const getUserDeptAndUnit = "/UserDetails/GetUserDeptAndUnitData";

////Complaint Flow
export const InitiateComplaintAsync = "/Custom/InitiateComplaintAsync";

export const InitiateAcknowledgementAsync = "/Custom/InitiateAcknowledgementAsync";

export const InitiateSalesClosureAsync = "/Custom/InitiateSalesClosureAsync";

export const InitiateQAClosureAsync = "/Custom/InitiateQAClosureAsync";
export const getPowerBiReportId = "/api/PowerBI/GetReportId";
export const GetUserDeptAndUnitDataForReport =
    "/api/PowerBI/GetUserDeptAndUnitDataForReport";